import React from 'react';
import {Provider} from "../context/Context";
import Post from "../components/Post";

/**
 *
 */
class PostTemplate extends React.PureComponent {

    render = () => {
        return (
            <Provider router={this.props}>
                <Post heading={true}/>
            </Provider>
        );
    };
}

export default PostTemplate;